import { render, staticRenderFns } from "./AdminLanguages.vue?vue&type=template&id=eebce2b4&scoped=true&"
import script from "./AdminLanguages.vue?vue&type=script&lang=js&"
export * from "./AdminLanguages.vue?vue&type=script&lang=js&"
import style0 from "./AdminLanguages.vue?vue&type=style&index=0&id=eebce2b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebce2b4",
  null
  
)

export default component.exports